import { Divider, Grid, Typography, makeStyles } from '@material-ui/core';
import { colors } from 'design-system';

const useStyles = makeStyles({
  divider: {
    height: 1,
    backgroundColor: colors.gallery,
  },
  block: {
    marginTop: 20,
  },
});

type Props = {
  description: string;
  value: string;
};

const DescriptionItem = ({ description, value }: Props): JSX.Element => {
  const classes = useStyles();
  return (
    <>
      <Grid
        container
        alignItems="center"
        justifyContent="space-between"
        className={classes.block}
      >
        <Typography
          variant="caption"
          color="secondary"
          data-testid="item-description"
        >
          {description}
        </Typography>

        <Typography variant="body2" data-testid="item-value">
          {value}
        </Typography>
      </Grid>
      <Divider className={classes.divider} />
    </>
  );
};

export default DescriptionItem;
